const DRAWER_WIDTH = 240;

export {
  // eslint-disable-next-line import/prefer-default-export
  DRAWER_WIDTH,
};
